"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    ApplicationSettingsClient: Symbol("ApplicationSettingsClient"),
    ApplicationSettingsRoute: Symbol("ApplicationSettingsRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ApplicationSettingsRoute).to(_1.ApplicationSettingsRoute);
    bind(TYPES.ApplicationSettingsClient).to(_1.ApplicationSettingsClient);
});
exports.diModule = diModule;
